import component from './TrialNotificationBar.vue'
export default component
